import { Auth } from "shared/@auth/Auth";
import { useQuery, useMutation, useQueryClient } from "react-query";

export function useEventsVirtualGet(params) {
  const { ruleset, eventName, enabled = true } = params;
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isError, isLoading, refetch } = useQuery(
    ["linkedVirtualEvents"],
    () =>
      makeAuthedRequest(`v1/events/virtual/${ruleset}/${eventName}`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      enabled: enabled && !!ruleset && !!eventName,
      staleTime: 0,
    }
  );

  return {
    data,
    refetch,
    isError,
    isLoading,
  };
}
